import type { Mission } from '../missions.ts'

export const doi: Mission = {
  id: "doi",
  name: "U.S. Department of the Interior",
  short: "DOI",
  kind: "department",
  url: "https://www.doi.gov/",
  established: 1849,
  palette: {
    primary: "#01406e",
    secondary: "#582c17",
    accent: "#ffbe2e",
  },
  colorSource: {
    kind: "site",
    url: "https://www.doi.gov/",
  },
  motif: "bison",
  mission: {
    text: "The U.S. Department of the Interior protects and manages the Nation's natural resources and cultural heritage; provides scientific and other information about those resources; and honors its trust responsibilities or special commitments to American Indians, Alaska Natives, Native Hawaiians, and affiliated Island Communities.",
    url: "https://www.doi.gov/about",
  },
  fact: {
    text: "Congress created the Department on March 3, 1849, the last day of the 30th Congress, to take charge of the Nation's internal affairs.",
    url: "https://www.doi.gov/about/history",
  },
  seal: {
    file: "public/seals/doi.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_the_Interior.svg",
  },
  identifier: {
    about: "https://www.doi.gov/about",
    accessibility: "https://www.doi.gov/accessibility",
    foia: "https://www.doi.gov/foia",
    noFear: "https://www.doi.gov/pmb/eeo/no-fear-act",
    oig: "https://www.doioig.gov/",
    performance: "https://www.doi.gov/performance",
    privacy: "https://www.doi.gov/privacy",
  },
  media: {
    photos: [
      {
        file: "/media/doi-utah-dunes.jpg",
        small: "/media/doi-utah-dunes-sm.jpg",
        alt: "Wind-sculpted sand dunes in soft evening light, with a snow-capped desert mountain range behind them.",
        title: "Little Sahara Recreation Area, West Desert District, Utah",
        creator: "Bob Wick, Bureau of Land Management",
        source: "https://commons.wikimedia.org/wiki/File:Utah_Dunes_Landscape_-_West_Desert_District.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/doi-seedskadee.jpg",
        small: "/media/doi-seedskadee-sm.jpg",
        alt: "Mist rising off the Green River at sunrise, with frosted cottonwoods and sagebrush along its banks.",
        title: "Frosty sunrise at Seedskadee National Wildlife Refuge, Wyoming",
        creator: "Tom Koerner, U.S. Fish and Wildlife Service",
        source: "https://commons.wikimedia.org/wiki/File:Frosty_sunrise_at_Seedskadee_National_Wildlife_Refuge_(51897484423).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
    video: {
      webm: "/media/doi-loop.webm",
      mp4: "/media/doi-loop.mp4",
      poster: "/media/doi-loop-poster.jpg",
      title: "Bison grazing, Lamar Valley, Yellowstone National Park",
      creator: "Neal Herbert, National Park Service",
      source: "https://www.nps.gov/media/video/view.htm?id=2BD36633-8359-4693-8F78-27BFEB98AB0D",
      license: "Public domain (U.S. government work)",
    },
  },
}
